import React from 'react';

export default function StepBranch({ data, errors, update, branches, loading }) {
  const handleSelect = (branch) => {
    const cid = branch.cid || branch.CID || branch.company_id || branch.COMPANY_ID || '';
    update('branch_id', branch.branch_id);
    update('branch_name', branch.branch_name);
    update('cid', cid);
    update('positions', branch.positions || []);
    update('position_applying', '');
    update('job_title', '');
  };

  return (
    <div>
      <h2 className="section-title">Select a Branch</h2>
      {loading ? (
        <p>Loading branches...</p>
      ) : branches.length === 0 ? (
        <p style={{ color: 'red' }}>Failed to load branches. Please refresh.</p>
      ) : (
        branches.map(branch => (
          <label
            key={branch.branch_id}
            className={`branch-option ${data.branch_id === branch.branch_id ? 'active' : ''}`}
          >
            <input
              type="radio"
              name="branch_id"
              checked={data.branch_id === branch.branch_id}
              onChange={() => handleSelect(branch)}
            />
            <span className="checkmark"></span>
            {branch.branch_name}
          </label>
        ))
      )}
      {errors.branch_id && <div className="error-text">{errors.branch_id}</div>}
    </div>
  );
}
